var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnderline11(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 315 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.893 22.995c40.044-2.081 80.098-4.172 120.142-6.253 39.844-2.072 79.689-4.143 119.533-6.224l67.43-3.512V1.003c-28.127 2.021-56.264 4.032-84.391 6.053-28.027 2.011-56.053 4.023-84.09 6.024-15.8 1.13-31.599 2.26-47.399 3.402-1.621.12-3.002 1.3-3.002 3.001 0 1.531 1.381 3.122 3.002 3.002 28.127-2.021 56.264-4.032 84.391-6.053 28.027-2.012 56.054-4.023 84.091-6.024 15.799-1.13 31.599-2.261 47.398-3.402 1.621-.12 3.002-1.3 3.002-3.001 0-1.561-1.371-3.082-3.002-3.002-40.044 2.081-80.098 4.172-120.142 6.253-39.844 2.072-79.688 4.143-119.532 6.224L3.893 16.992c-3.842.2-3.872 6.203 0 6.003z",
    fill: "#121318",
    stroke: "#121318",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgUnderline11;